/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/*
 * The file is automatically generated by Serenity UI.
 *
 * ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
 *
 * Found an issue? Submit a task to the ClickUp board:
 * https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
 */
import * as stylex from '@stylexjs/stylex';
import { type ForwardedRef, type ReactElement, createContext, forwardRef } from 'react';
import type { UNSTABLE_ToastQueue } from 'react-aria-components';
import {
  type ContextValue,
  UNSTABLE_ToastRegion as ToastRegionCore,
  type ToastRegionProps as ToastRegionCoreProps,
  useContextProps,
} from 'react-aria-components';
import { flushSync } from 'react-dom';
import { zIndices } from '../../constants.stylex';

interface ToastRegionProps<T> extends Omit<ToastRegionCoreProps<T>, 'style' | 'className'> {
  /** The slot of the toast region. */
  slot?: string;
  /** The placement of the toast region. */
  placement?: keyof typeof positionVariants;
  style?: stylex.StyleXStyles;
}

const ToastRegionContext = createContext<ContextValue<ToastRegionProps<object>, HTMLDivElement>>({});

const ToastRegion = forwardRef((props: ToastRegionProps<object>, ref: ForwardedRef<HTMLDivElement>) => {
  [props, ref] = useContextProps(props, ref, ToastRegionContext);

  const { style, children, placement = 'topCenter', ...coreProps } = props;

  return (
    <ToastRegionCore ref={ref} {...stylex.props(styles.base, positionVariants[placement], style)} {...coreProps}>
      {children}
    </ToastRegionCore>
  );
}) as <T>(p: ToastRegionProps<T> & { ref?: ForwardedRef<HTMLDivElement> }) => ReactElement;

const styles = stylex.create({
  base: {
    inset: 0,
    padding: 35,
    gap: 8,
    outline: 'none',
    boxSizing: 'border-box',
    display: 'flex',
    pointerEvents: 'none',
    position: 'fixed',
    zIndex: zIndices.toast,
  },
});

const positionVariants = stylex.create({
  topLeft: {
    alignItems: 'flex-start',
    flexDirection: 'column',
    justifyContent: 'flex-start',
  },
  topCenter: {
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'flex-start',
  },
  topRight: {
    alignItems: 'flex-end',
    flexDirection: 'column',
    justifyContent: 'flex-start',
  },
  bottomLeft: {
    alignItems: 'flex-start',
    flexDirection: 'column-reverse',
    justifyContent: 'flex-start',
  },
  bottomCenter: {
    alignItems: 'center',
    flexDirection: 'column-reverse',
    justifyContent: 'flex-start',
  },
  bottomRight: {
    alignItems: 'flex-end',
    flexDirection: 'column-reverse',
    justifyContent: 'flex-start',
  },
});

const TOAST_QUEUE_CONFIG: ConstructorParameters<typeof UNSTABLE_ToastQueue>[0] = {
  wrapUpdate(fn: () => void) {
    if ('startViewTransition' in document) {
      document.startViewTransition(() => {
        flushSync(fn);
      });
    } else {
      fn();
    }
  },
  maxVisibleToasts: 3,
};

export { TOAST_QUEUE_CONFIG, ToastRegion, ToastRegionContext, type ToastRegionProps };
